import React, { useState } from "react";
import Image from "next/image";
export default function Banner({ project }) {
  const {
    year,
    projectType,
    location,
    shortDescription,
    shortTitle,
    size,
    title,
    site,
  } = project ?? "";

  const statsData = [
    {
      title: "Status",
      value: year === "Ongoing" ? "Ongoing" : "Completed",
    },
    {
      title: "Location",
      value: location,
    },
    {
      title: "Area",
      value: size,
    },
    {
      title: "Category",
      value: projectType,
    },
  ];
  const [showFullDescription, setShowFullDescription] = useState(false);
  const truncatedDescription = shortDescription?.slice(0, 150) ?? "";
  return (
    <div className="relative lg:h-[calc(100vh+248px)] md:h-[calc(100vh)] h-[750px] w-full">
      <Image
        src={
          project?.banner?.data?.attributes?.url ?? "/images/placeholder.svg"
        }
        alt={project?.banner?.data?.attributes?.alternativeText ?? "banner"}
        sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw, 100vw"
        className="w-full h-auto object-cover object-center md:block hidden"
        priority
        quality={90}
        fill
      />
      <Image
        src={
          project?.mobileBanner?.data?.attributes?.url ??
          project?.banner?.data?.attributes?.url ??
          "/images/placeholder.svg"
        }
        alt={
          project?.mobileBanner?.data?.attributes?.alternativeText ?? "banner"
        }
        sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw, 100vw"
        className="w-full h-auto object-cover object-center md:hidden"
        priority
        quality={90}
        fill
      />
      <div className="bg-black/10 w-full h-full absolute top-0 left-0 flex flex-col items-center justify-end">
        <div className="flex lg:flex-row flex-col items-center justify-between w-full md:p-8 p-4 lg:gap-0 gap-4">
          <p className="text-[#e9e7de]/80 text-sm shrink-0 lg:block hidden">
            {site}
          </p>
          <h1 className="font-havletica font-light text-[#f6f5f1] text-center">
            {title}
          </h1>
          <div className="flex items-center lg:w-fit w-full lg:justify-end justify-between">
            <p className="text-[#e9e7de]/80 text-sm shrink-0 lg:hidden">
              {site}
            </p>
            <p className="text-[#e9e7de]/80 text-sm shrink-0">{location}</p>
          </div>
        </div>
        <div className="flex md:flex-row flex-col md:justify-between items-center justify-center w-full bg-black/60 md:p-8 p-4 lg:min-h-[248px] md:min-h-[280px] min-h-[420px] gap-4 lg:gap-0">
          <div className="flex flex-col lg:max-w-[543px] md:max-w-[350px] gap-3 pt-2 lg:pt-0">
            {shortTitle && (
              <p className="text-[#F6F5F1]/70 lg:text-[20px] md:text-base text-sm font-havletica leading-tight">
                {shortTitle}
              </p>
            )}
            {shortDescription && (
              <div className="[&>*]:text-sm font-light text-[#F6F5F1]/70 leading-tight block lg:hidden">
                <div
                  dangerouslySetInnerHTML={{
                    __html: showFullDescription
                      ? shortDescription
                      : truncatedDescription +
                        (shortDescription.length > 200 ? "..." : ""),
                  }}
                ></div>
                {shortDescription.length > 200 && (
                  <button
                    className="text-white underline text-sm mt-2"
                    onClick={() => setShowFullDescription(!showFullDescription)}
                  >
                    {showFullDescription ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
            )}
            {shortDescription && (
              <div className="[&>*]:text-sm font-light text-[#F6F5F1]/70 leading-tight hidden lg:block">
                <div
                  dangerouslySetInnerHTML={{
                    __html: shortDescription,
                  }}
                ></div>
              </div>
            )}
          </div>
          <div className="flex flex-col lg:max-w-[350px] md:max-w-[250px] w-full">
            {statsData?.map(
              (stat, key) =>
                stat?.value !== null &&
                stat?.value !== "" && (
                  <Stat
                    key={"stat" + key}
                    title={stat.title}
                    value={stat?.value}
                  />
                )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
const Stat = ({ title, value }) => {
  return (
    <div className="flex items-center justify-between last:border-b-0 border-[#e9e7de]/50 border-b-[1px] py-4">
      <p className="text-sm text-[#e9e7de]">{title}</p>
      <p className="text-sm text-[#e9e7de]/60">{value}</p>
    </div>
  );
};
